import React from 'react';
import { withRouter, NavLink } from 'react-router-dom'
import { AuthContext } from '../../contexts/AuthContext'
import styled from 'styled-components'
import { isAuthenticated, logout } from '../../auth'
import api from '../../services/api';

const StyledSideBar = styled.div`
background-color: rgba(41, 107, 169, 1);
box-shadow: 0px 0px 8px 0px;
width: 250px;
height: 90vh;
display: ${props => props.visible ? 'flex' : 'none'};
flex-direction: column;
justify-content: center;
`

const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgba(8, 33, 60, 1);
  margin-top: 5px;
`

const LinkWrapper = styled.div`
  display: contents;
  width: 100%;
  height: 90vh;
`

const StyledLinkCourse = styled(NavLink)`
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  margin: 0px 8px;
  font-weight: 400;
  font-size: 13px;
  &:hover {
    text-decoration: none;
    color: #ddd;
  }
  &:active {
    font-weight: bold;
  }
`

const StyledLinkClass = styled(NavLink)`
  color: #fff;
  font-size: 16px;
  margin: 5px 55px;
  text-decoration: none;
  font-weight: 400;
  &:hover {
    text-decoration: none;
    color: #ddd;
  }
  &:active {
    font-weight: bold;
  }
`

const StyledSidebarText = styled.div`
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  font-weight: 400;
  margin: 0px 8px;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #ddd;
  }
  &:active {
    font-weight: bold;
  }
`

function Sidebar(props) {
  const { auth, dispatch } = React.useContext(AuthContext)
  const [activeCourse, setActiveCourse] = React.useState('')
  const [show, setShow] = React.useState(false)
  const [courses, setCourses] = React.useState([])

  React.useEffect(() => {
    if (auth.user) {
      api.post('/student/get-all-courses', { user: auth.user._id }).then(res => {
        setCourses(res.courses)
      })
    }
  }, [auth.user])

  React.useEffect(() => {
    setShow(false)
    const path = props.location.pathname.split("/")
    if (path.length > 2) {
      setActiveCourse(path[2]);
    } else {
      setActiveCourse('')
    }
    if (auth.user) {
      setShow(true)
    }
    if (props.location.pathname === "/dashboard" || props.location.pathname.indexOf("/buy/") === 0 || props.location.pathname.indexOf("/highlighter/") !== -1) {
      setShow(false)
    }
  }, [props.location, auth.user, dispatch])

  function logoutFunction() {
    dispatch({ type: "SIGN_OUT" })
    logout()
    props.history.push("/")
  }
  return (
    <div className={'d-none d-sm-block'}>
      <StyledSideBar visible={show}>
        <LinkWrapper>
          <StyledLinkCourse to="/dashboard">Home</StyledLinkCourse>
          {courses.map(course => <div style={{overflowY: 'auto', maxHeight: '70%'}} key={`course_menu_${course._id}`}>
            <StyledLinkCourse to={`/course/${course._id}`}>{course.name}</StyledLinkCourse>
            {activeCourse === course._id && <LinkGroup>
              {course.lectures.map((lecture, index) => {
                if (lecture.visibility)
                  return <StyledLinkClass key={`lectures_sidebar_${lecture._id}`} to={`/course/${course._id}/class/${lecture._id}`} >{lecture.title}</StyledLinkClass>
              })}
            </LinkGroup>}
          </div>)}
          {isAuthenticated() && <>
            <StyledLinkCourse to="/profile">Meu Perfil</StyledLinkCourse>
            <StyledSidebarText onClick={() => { logoutFunction() }}>Sair</StyledSidebarText>
          </>}
        </LinkWrapper>
      </StyledSideBar>
    </div>
  );
}

export default withRouter(Sidebar);
